"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeHttpUrl = safeHttpUrl;
exports.isAllowedHumlaS3Url = isAllowedHumlaS3Url;
const SAFE_PROTOCOLS = new Set(['http:', 'https:']);
/**
 * Returns the value unchanged when it parses as an absolute http(s) URL, otherwise undefined.
 * Parsing rather than prefix-matching is what catches schemes the URL constructor normalizes,
 * such as `java\tscript:`. The original string is returned rather than a re-serialized one so
 * that signed query parameters stay byte-identical.
 */
function safeHttpUrl(value) {
    if (!value)
        return undefined;
    try {
        return SAFE_PROTOCOLS.has(new URL(value).protocol) ? value : undefined;
    }
    catch {
        return undefined;
    }
}
// Security: restrict server-side fetches of "document" URLs to known Humla S3 buckets so the
// fetching endpoint cannot be used as an open HTTP proxy / SSRF vector. Mirrors the check that
// originated in mcp/humla-api-readonly/src/tools/documents.ts; kept here so every server-side
// call site (MCP fetch_document, admin-chat attachment fetch) shares one implementation.
const ALLOWED_S3_HOSTNAME_PATTERN = /^[\w-]+(\.s3\.[\w-]+\.amazonaws\.com|\.s3\.amazonaws\.com)$/;
const ALLOWED_S3_BUCKET_PREFIXES = [
    /^[\w-]+-clh-/, // Current pattern: ${env}-clh-*
    /^humla-health-/, // Legacy pattern
    /^humla-documents-/, // Localdev pattern
];
/**
 * True only when `url` is an https URL whose host is a Humla-owned S3 bucket
 * (`<bucket>.s3.<region>.amazonaws.com` or `<bucket>.s3.amazonaws.com`) and whose bucket name
 * carries an allowed prefix. Everything else — non-https schemes, non-S3 hosts, foreign buckets,
 * link-local/metadata addresses — returns false. Purely structural: it never performs a network
 * request or DNS lookup, so callers can reject before fetching.
 */
function isAllowedHumlaS3Url(url) {
    let parsed;
    try {
        parsed = new URL(url);
    }
    catch {
        return false;
    }
    if (parsed.protocol !== 'https:')
        return false;
    if (!ALLOWED_S3_HOSTNAME_PATTERN.test(parsed.hostname))
        return false;
    const bucketName = parsed.hostname.split('.s3.')[0];
    return ALLOWED_S3_BUCKET_PREFIXES.some((prefix) => prefix.test(bucketName));
}
//# sourceMappingURL=safe-url.js.map